import { createContext } from "react";

export const SectionContenxt = createContext({
  currentSection: "",
  handleChangeSection: () => {},
});
